module.exports = __webpack_public_path__ + "img/logo.a13f81dd.jpg";